import React from 'react';
import logo from '../images/hosteldesk-studway-logo.png';
import icon from '../images/hosteldesk-studway-icon.png';
import './Brand.css';

export default function Brand({ width, compact = false, className = '', surface = false, dark = false }) {
  const size = width || 190;
  if (dark && !compact) return <span className={`hd-dark-brand ${className}`} role="img" aria-label="HostelDesk by STUDWAY" style={{ width: size }}><b>Hostel<span>Desk</span></b><small>By <strong>STUDWAY</strong></small></span>;
  return <span className={`lp-brand ${className}`} style={surface ? { background: '#fff', borderRadius: 10, padding: '4px 8px' } : undefined}>
    <img src={compact ? icon : logo} alt="HostelDesk by STUDWAY" width={size} height={compact ? size : size / 3}
      style={width ? { width, height: compact ? size : size / 3 } : undefined} />
  </span>;
}
